import React from 'react';
import DashboardHeader from '../../components/DashboardHeader';
import DashboardFooter from '../../components/DashboardFooter';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingRight: '10%',
    paddingLeft: '10%',
    paddingTop: '50px'
  },
}));

export default function ApproverLayout({children}) {
  const classes = useStyles();
  const createMenus = (path, name) => {
    return {path, name};
  };

  const menus = [
    createMenus('/ui/approver-view', 'Approvals'),
  ];

  return (
    <div id="body-container">
      <DashboardHeader menus={menus}/>
      <div className={classes.wrapper} >
        {children}
      </div>
      <DashboardFooter />
    </div>
  );
}